import mountVues from "@galaxy/modules/Core/resources/js/mountVues";

common.View.create('crud::form.Ajax', {

    ajaxCalls: [],

    oldValues: [],

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.saveOldValues();

        if( this.element.data('run-on-load') ) {
            this.initAjax();
        }
    },

    saveOldValues()
    {
        this.element.find('input, select, textarea')
            .on('change', (event) => {
                // Is radio or checkbox? Then save checked
                if( ['checkbox', 'radio'].includes(event.currentTarget.type) ) {
                    this.oldValues[event.currentTarget.name] = event.currentTarget.checked;
                } else {
                    this.oldValues[event.currentTarget.name] = event.currentTarget.value;
                }
            });
    },

    /**
     * Initializes the GUI.
     */
    initAjax()
    {
        let $input = this.getInputs(this.element.data('input')),
            inputName = this.getInputName(this.element.data('input'));

        // Find input that will activate the postback
        $('html,body')
            // On change event of that input
            .on(this.element.data('trigger'), inputName, (event) =>
            {
                // Re-render view based on input change
                this.viewRerender(event.currentTarget);
            })
            .end();

        this.viewRerender($input);
    },

    getInputName(input)
    {
        if( input.includes('*') ) {
            return '[name*="' + input.replace('*', '') + '"]';
        } else {
            return '[name="' + input + '"]';
        }
    },

    getInputs(input)
    {
        let $input = $('html, body');

        $input = $input.find(this.getInputName(input));

        return $input;
    },

    viewRerender(input)
    {
        let dataAction = this.element.data('action');

        if( dataAction?.action && this.ajaxCalls[dataAction.action] ) {
            this.ajaxCalls[dataAction.action].abort();
            this.ajaxCalls.splice(this.ajaxCalls[dataAction.action], 1);
        } else {
            for (const ajaxCall of this.ajaxCalls) {
                ajaxCall.abort();
                this.ajaxCalls.splice(this.ajaxCalls[ajaxCall], 1);
            }
        }

        // Also send additional fields?
        let inputExtraValues = [];
        if( this.element.data('input_extra') ) {
            for(const inputExtra of this.element.data('input_extra')) {
                let $inputs = this.getInputs(inputExtra);

                for(const input of $inputs) {
                    inputExtraValues.push({
                        name: $(input).attr('name'),
                        value: this.getCurrentInputValue(input)
                    });
                }

            }
        }

        // Re-render view
        let ajaxCall = $.post('/galaxy/crud/' + ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'form/ajax', {
            'input': this.getCurrentInputValue(input),
            'input_extra': JSON.stringify(inputExtraValues),
            'view': this.element.data('view'),
            'action': this.element.data('action'),
        }).done((data) => {
            this.element.find('.ajaxContent').html(data);

            // Re-enter old values in inputs
            this.reEnterOldValues();

            // Re init vue
            mountVues(this.element);

            // Run trigger
            this.element.trigger('crud::form-ajax:change');

            // Re init view
            common.View.reinit();

            // Re-init save old values since we want to track the new changes
            this.saveOldValues();
        });

        if( dataAction?.action ) {
            this.ajaxCalls[dataAction.action] = ajaxCall;
        } else {
            this.ajaxCalls.push(ajaxCall);
        }
    },

    getCurrentInputValue(input)
    {
        // Is checkable?
        if ($.inArray($(input).attr('type'), ['checkbox', 'radio']) !== -1) {
            return $('input[name="' + input.name + '"]:checked').val();
        }

        // Is switch input?
        if ($(input).parents('[class*="crud::form-inputs"]').is('[class*="Switch"]')) {
            return $(input).attr('checked');
        }

        return $(input).val();
    },

    reEnterOldValues()
    {
        for(let key in this.oldValues) {
            // Find element
            let $element = this.element.find('[name="' + key + '"]'),
                value = this.oldValues[key];

            if( ['checkbox', 'radio'].includes($element.attr('type')) ) {
                this.element.find('[name="' + key + '"]').prop('checked', value);
            } else {
                this.element.find('[name="' + key + '"]').val(value);
            }
        }
    }

});
